import "index.css";
// Import all javascript files from src/_components
const componentsContext = require.context("bridgetownComponents", true, /.js$/);
componentsContext.keys().forEach(componentsContext);

console.info("Willkommen bei Eine Prise Herz! ❤️");
